import { createContext, useEffect, useState } from 'react';
import useCities from '../hooks/useCities';

export const FiltersContext = createContext();

export const filtersInitialState = {
    cidade: {
        value: '',
        label: 'Todas',
        governance_room_client_city_id: null,
        governance_room_geo_city_id: null
    },
    unidade: {
        value: '',
        label: 'Todos'
    },
    ano: {
        value: new Date().getFullYear().toString(),
        label: new Date().getFullYear().toString()
    },
    competencia: {
        value: '',
        label: 'Todos'
    },

    data_inicio: '1960-01-01',
    data_fim: new Date().toISOString().split('T')[0]
};

const FiltersProvider = ({ children, initialState }) => {
    const [filters, setFilters] = useState(() => {
        const state = initialState || filtersInitialState;

        const savedCity = localStorage.getItem('dashboard_city');

        return savedCity ? { ...state, cidade: JSON.parse(savedCity) } : state;
    });
    const { data: cities } = useCities();

    const handleChangeFilters = (values) => {
        setFilters(values);
    };

    const resetFilters = () => {
        setFilters((previous) => ({
            ...(initialState || filtersInitialState),
            cidade: previous.cidade
        }));
    };

    useEffect(() => {
        if (cities && cities.length > 0 && !filters.cidade.value) {
            onFilterChange('cidade', cities[0]);
        }
    }, [cities]);

    useEffect(() => {
        if (filters.cidade.value) {
            localStorage.setItem(
                'dashboard_city',
                JSON.stringify(filters.cidade)
            );
        }
    }, [filters.cidade]);

    const onFilterChange = (name, value) => {
        const newFilters = { ...filters, [name]: value };

        if (name === 'cidade') {
            newFilters.unidade = { value: '', label: 'Todos' };
        }

        handleChangeFilters(newFilters);
    };

    return (
        <FiltersContext.Provider
            value={{
                filters,
                handleChangeFilters,
                resetFilters,
                onFilterChange,
                cities: cities || []
            }}
        >
            {children}
        </FiltersContext.Provider>
    );
};

export default FiltersProvider;
